module.exports = __webpack_public_path__ + "static/img/tfqq.982f0b4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/tfqq.png
// module id = QBOg
// module chunks = 0